export default { 
  type: 'string', 
  label: 'String',
  shape: 'circle'
}